<script setup>
import { ref, computed } from "vue";
import { useGlobalStore } from "@stores/global.js";
import { useShopifyStore } from "@stores/shopify.js";
import { Swiper, SwiperSlide } from "swiper/vue";
import ArrowLeft from "@components/icons/ArrowLeft.vue";
import ArrowRight from "@components/icons/ArrowRight.vue";
import "swiper/css";

const global = useGlobalStore();
const shopify = useShopifyStore();

const slider = ref({});
const breakpoints = {
	0: {
		slidesPerView: 3.5,
		spaceBetween: 8,
	},
	768: {
		slidesPerView: 5.5,
		spaceBetween: 8,
	},
	1024: {
		slidesPerView: 8,
		spaceBetween: 8,
	},
};

const onSwiper = (swiper) => {
	slider.value = swiper;
};

const collections = computed(() => shopify.teamsCollections);
</script>

<template>
	<section
		v-if="collections.length > 0"
		class="overflow-hidden py-48 lg:py-80"
	>
		<div class="container">
			<div class="relative isolate">
				<Swiper
					@swiper="onSwiper"
					:breakpoints="breakpoints"
					class="overflow-visible!"
				>
					<SwiperSlide
						v-for="collection in collections"
						:key="collection.id"
					>
						<router-link
							:to="{
								name: 'collection',
								params: { slug: collection.slug },
							}"
							class="group"
							@mouseenter="
								if (global.pointerFine) {
									global.setHeaderTheme(
										collection.theme?.background,
										collection.theme?.accent,
										collection.theme?.surface,
									);
								}
							"
							@mouseleave="global.setHeaderTheme(null, null, null)"
						>
							<div
								class="bg-bg-base flex aspect-square items-center justify-center rounded-lg p-16 transition-colors group-hover:bg-neutral-200"
							>
								<img
									v-if="collection?.icon"
									:src="collection?.icon"
									:alt="collection?.icon_alt || collection?.title"
									class="size-64 object-contain transition-transform duration-300 group-hover:scale-[1.1] md:size-80"
								/>
							</div>
							<p
								class="h6 font-primary-condensed mt-16 text-center"
								v-if="collection.initials"
							>
								{{ collection.initials }}
							</p>
						</router-link>
					</SwiperSlide>
				</Swiper>
				<button
					class="group bg-bg-inverted text-text-inverted absolute top-1/2 -left-24 z-10 hidden size-48 -translate-y-1/2 items-center justify-center rounded-full transition-all md:flex"
					@click.stop="slider.slidePrev()"
					aria-label="Previous"
					v-if="!slider.isBeginning"
				>
					<ArrowLeft class="size-14 group-hover:opacity-75" />
				</button>
				<button
					class="group bg-bg-inverted text-text-inverted absolute top-1/2 -right-24 z-10 hidden size-48 -translate-y-1/2 items-center justify-center rounded-full transition-all md:flex"
					@click.stop="slider.slideNext()"
					aria-label="Next"
					v-if="!slider.isEnd"
				>
					<ArrowRight class="size-14 group-hover:opacity-75" />
				</button>
			</div>
		</div>
	</section>
</template>
